
import { useDispatch } from 'react-redux';
import usePostApi from '../../../../../../config/hooks/api/post/usePostApi';
import { setError, setMessage } from '../../../../../../store/common/generalSlice';
import DynamicForm from '../../../../../../components/FormElements/DynamicForm';
import * as Yup from 'yup'
import Button from '../../../../../../components/FormElements/Button';

const ReportPostPoll = ({ postData, closeModal, refreshFeed }) => {
    const dispatch = useDispatch()
    const { reportPoll, reportPost } = usePostApi()

    const handleSubmit = async (values) => {
        try {
            if(values){
                const { reportType: type, reportReason: reason } = values
                if(!postData.id || !postData.type){
                    dispatch(setError('Something went wrong'))
                    return
                }
                
                let response;
                const payload = { 
                    type,
                    reason,
                    resourceType: postData?.type,
                    resourceUserId: postData?.user?.id
                }
                if (postData?.type.toLowerCase() == 'post') response = await reportPost(payload, postData?.id)
                else response = await reportPoll(payload, postData?.id)
                if (response) {
                    dispatch(setMessage(response?.data?.message))
                    refreshFeed()
                    closeModal()
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    // Define the form configuration
    const reportform = {
        name: 'reportPostForm',
        formFields: [
            {
                name: 'reportType',
                type: 'select',
                label: { value: '', style: '', classes: '' },
                options: [
                    { name: 'Fake', value: 'Fake' },
                    { name: 'Inappropriate', value: 'Inappropriate' },
                    { name: 'Spam', value: 'Spam' },
                ],
                multiple: false,
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
            {
                name: 'reportReason',
                type: 'textarea',
                label: { value: '', style: '', classes: '' },
                placeholder:'Write Description',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
        ],
        formValidation: {
            reportType: Yup.string().required('Report Type is required'),
            reportReason: Yup.string().
                required('Report Reason is required').
                min(3, 'Reason should be at least 3 character long').
                max(30, 'Reason should not exceed 30 characters')

        },
    };


    const submitForm = () => {
        document.querySelector('form#reportPostForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    return (
        <div>
            <h5 className='heading-5 font-bold text-center'>
                Report { postData && postData.type && postData.type.slice(0,1).toUpperCase() + postData.type.slice(1).toLowerCase() }
            </h5>
            <DynamicForm id='reportPostForm' form={reportform} onSubmit={handleSubmit} />
            <Button.Basic 
              onClick={submitForm}
              disabled={false}
              icon={null}
              loading={false}
              type="primary" 
              size='medium'
              text='Submit'
              className='btn-primary w-full'
            />
        </div>
    )
}

export default ReportPostPoll